<template>
  <div class="intro-box">
    <slot />
    <div v-if="postAuthor" class="intro-box__author" v-html="postAuthor" />
  </div>
</template>

<script lang="ts">
export default {
  props: {
    postAuthor: String,
  },
};
</script>

<style lang="scss">
@use "~/common/scss/variables";
@use "~/common/scss/helpers";

.intro-box {
  background-color: variables.$colorGreyED;
  border: none;
  border-radius: 0 0 5px 5px;
  color: variables.$colorBlack;
  font-weight: 300;
  margin: 0 auto helpers.px-to-rem(40);
  max-width: variables.$containerMediumSmall;
  padding: helpers.px-to-rem(40) helpers.px-to-rem(40) helpers.px-to-rem(40);
  transform: translateY(-2px);

  &__author {
    color: variables.$colorGrey;
    padding-top: 1rem;
  }
}
</style>
